import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bb4d102"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "details-content" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "content" }

import SettingsDetails from "@/components/settings/SettingsDetails/SettingsDetails.vue";
import Form from "@/components/layouts/Form.vue";
import GenericButton from "@/components/buttons/GenericButton.vue";
import { ActionTypes } from "@/store";
import { Chat } from "@/store/chats/types";
import { FormFieldNameEnum } from "@/types/form";
import { computed, ref } from "vue";
import { useGetChatSettingsCommonProperties } from "../useGetChatSettingsCommonProperties";
import { GenericButtonVariantEnum } from "@/types/button";
import Input from "@/components/forms/Input.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatSettingsRenameGroupConversation',
  setup(__props) {

const { selectedChatId, route, router, dispatch, getters } =
  useGetChatSettingsCommonProperties();

const chatId = computed(() => {
  return selectedChatId.value ?? (route.params.chat_id as string);
});
const chatDetail = computed<Chat>(() => {
  return getters.GET_CONVERTED_CHAT_DETAIL(chatId.value);
});

const name = computed(() => chatDetail.value.name ?? "");

const nameValue = ref(name.value);

const handleSubmit = async () => {
  await dispatch(ActionTypes.UPDATE_GROUP_CHAT, {
    chatId: chatId.value,
    name: nameValue.value,
  });

  router.back();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SettingsDetails, {
    title: _ctx.$t('settings.chat.renameGroup.title')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Form, { onSubmitForm: handleSubmit }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(Input, {
                  modelValue: nameValue.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nameValue).value = $event)),
                  name: _unref(FormFieldNameEnum).Name,
                  label: "settings.chat.renameGroup.groupName",
                  required: ""
                }, null, 8, ["modelValue", "name"])
              ]),
              _createVNode(GenericButton, {
                variant: _unref(GenericButtonVariantEnum).Primary,
                text: "settings.personalDetailsContent.saveDetails"
              }, null, 8, ["variant"])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})